var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "buttonTypeCustom",
      class: [
        _vm.buttonColor,
        _vm.buttonSize,
        {
          isPc: !_vm.isSp,
          buttonNoMaxWidth: _vm.buttonNoMaxWidth,
          maxWidthNone: _vm.maxWidthNone,
        },
      ],
      attrs: { type: _vm.buttonType },
      on: {
        click: function ($event) {
          return _vm.clicked($event)
        },
        mousedown: _vm.onMousedown,
      },
    },
    [_vm._v("\n  " + _vm._s(_vm.buttonText) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }